import { PropsWithChildren, useMemo } from "react";
import { TextProps, TextStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";
import Text from "./Text";

type ScreenTitleProps = PropsWithChildren<{
    style?: TextStyle;
    mode?: "large" | "small" | "medium";
}> &
    TextProps;

const ScreenTitle = ({ children, style, mode = "large", ...props }: ScreenTitleProps) => {
    const { fonts } = useTheme();
    const titleStyle = useMemo(() => {
        if (mode == "large") {
            return fonts.titleLarge;
        }
        if (mode == "small") {
            return fonts.titleSmall;
        }
        if (mode == "medium") {
            return fonts.titleMedium;
        }
        return null;
    }, [fonts.titleLarge, fonts.titleMedium, fonts.titleSmall, mode]);
    return (
        <Text {...props} style={[titleStyle, style, { lineHeight: 43.2 }]}>
            {children}
        </Text>
    );
};

export default ScreenTitle;
